import { StringUtility } from './string';

export class ObjectUtility {
  static extractDataFromObject<T extends Object, K extends keyof T>(
    object: T,
    properties: Array<K>,
    valueAccessors: { [key in K | string]?: (object: T) => any } = {}
  ): T {
    const result: T = {} as T;
    const pendingAccessors = { ...valueAccessors };
    properties.forEach(property => {
      let value = object[property];
      const valueAccessorFn = valueAccessors[property];
      if (valueAccessorFn) {
        value = valueAccessorFn(object);
        delete pendingAccessors[property];
      }
      if (ObjectUtility.isNil(value)) {
        return;
      }
      result[property] = value;
    });
    const pendingAccessorKeys = Object.keys(pendingAccessors);
    if (pendingAccessorKeys.length) {
      pendingAccessorKeys.forEach(property => {
        const accessorFn = pendingAccessors[property];
        const value = accessorFn(object);
        if (ObjectUtility.isNil(value)) {
          return;
        }
        result[property] = value;
      });
    }

    Object.keys(result).forEach(property => {
      result[property] = StringUtility.trimIfString(result[property]);
    });

    return result;
  }

  static isNil<T>(value: T): boolean {
    return value === null || value === undefined;
  }
}
